export default __webpack_public_path__ + "static/media/Banner_04.35121b1f.png";